const e = "_table_12j7s_1", l = "_header_12j7s_10", s = "_cell_12j7s_18", t = {
  table: e,
  header: l,
  cell: s
};
export {
  s as cell,
  t as default,
  l as header,
  e as table
};
//# sourceMappingURL=Table.module.css.js.map
